<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <th>№</th>
          <th>Название курса</th>
          <th>Вид обучения</th>
          <th class="text-center">Период</th>
          <th>Статус</th>
          <th class="progress-column text-center">Обучение</th>
          <th class="progress-column text-center">Тестирование</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in items" :key="index" class="border-bottom border-left border-right">
          <td>{{ index + 1 }}</td>
          <td>
            <a :href="row.course_url" :style="{pointerEvents:  row.button_course_status ? 'auto' : 'none'}" class="link">{{ row.name }}</a>
          </td>
          <td class="text-nowrap">{{ row.education_type }}</td>
          <td class="text-nowrap">{{ row.date_start }} - {{ row.date_end }}</td>
          <td>{{ row.status }}</td>
          <td>
            <div style="background: rgb(0,108,255);" class="rounded">
              <div :style="{ background: 'linear-gradient(90deg, rgba(0,108,255,1)' + row.progress_slides + '%, rgba(157,157,157,1) 0%)' }"
                   class="text-center rounded white font-weight-bold">
                {{ row.progress_slides }}%
              </div>
            </div>
          </td>
          <td>
            <div style="background: rgb(0,108,255);" class="rounded" v-if="row.has_test">
              <div :style="{ background: 'linear-gradient(90deg, rgba(0,108,255,1)' + row.progress_tests + '%, rgba(157,157,157,1) 0%)' }"
                   class="text-center rounded white font-weight-bold">
                {{ row.progress_tests }}%
              </div>
            </div>
            <div style="text-align:center" v-else>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" style=" margin:0 auto; width: 2rem; height: 2rem;" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
            </div>
          </td>
          <td>
            <a :href="row.button_course_status ? row.course_url : ''">
              <button :disabled="!row.button_course_status" class="btn btn-primary">
                {{ row.button_course_text }}
              </button>
            </a>
          </td>
          <td>
            <button 
              :disabled="!row.button_exam_status" 
              :class="['btn', row.exam_limit ? 'btn-warning' : 'btn-secondary']" 
              @click="examButtonHandler(row)"
              :title="row.exam_limit ? `Экзамен станет доступен ${row.current_day}` : ''"
            >
              {{ row.button_exam_text }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- Практика не отмечена менеджером — к экзамену не пускаем -->
    <practice-required-modal v-if="showPracticeModal"
                             :practice-sheet-url="practiceSheetUrl"
                             @close="showPracticeModal = false" />

    <!-- Дистанционная практика -->
    <remote-practice-modal v-if="showRemotePracticeModal"
                           :sheet-url="remotePractice.sheetUrl"
                           :sign-url="remotePractice.signUrl"
                           :upload-url="remotePractice.uploadUrl"
                           :pep-allowed="remotePractice.pepAllowed"
                           @passed="onRemotePracticePassed"
                           @close="showRemotePracticeModal = false" />

    <!-- Модальное окно для пин-кода -->
    <div v-if="showPinModal" class="modal">
      <div class="modal-content">
        <h3>Введите пин-код куратора</h3>
        <input v-model="enteredPinCode" type="password" placeholder="Пин-код" @keyup.enter="verifyPinCode">
        <button type="button" class="btn btn-secondary btn-modal" @click="verifyPinCode">Проверить</button>
        <button class="btn btn-secondary btn-modal" @click="closeModal">Отмена</button>
        <p v-if="pinError" class="error">Неверный пин-код, попробуйте еще раз.</p>
      </div>
    </div>
  </div>
</template>

<script>
import PracticeRequiredModal from "./PracticeRequiredModal.vue";
import RemotePracticeModal from "./RemotePracticeModal.vue";

export default {
  components: {
    PracticeRequiredModal,
    RemotePracticeModal
  },
  props: {
    /** @type {EducationsData[]} */
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showPinModal: false,
      enteredPinCode: '',
      pinError: false,
      selectedExam: null, // хранит данные выбранного экзамена
      showPracticeModal: false,
      practiceSheetUrl: '',
      practiceAutoShown: false,
      remotePracticeAutoShown: false,
      showRemotePracticeModal: false,
      remotePractice: { sheetUrl: '', signUrl: '', uploadUrl: '', pepAllowed: false, examUrl: '' }
    }
  },
  watch: {
    // Пришли редиректом с /exam — сразу объясняем, почему экзамен не открылся
    items(rows) {
      this.autoShowPracticeModal(rows);
      this.autoShowRemotePracticeModal(rows);
    }
  },
  methods: {
    autoShowRemotePracticeModal(rows) {
      if (this.remotePracticeAutoShown) return;
      if (!/[?&]remote_practice_required=1/.test(window.location.search)) return;

      const row = rows.find((r) => r.remote_practice_block);
      if (!row) return;

      this.openRemotePracticeModal(row);
      this.remotePracticeAutoShown = true;
    },
    openRemotePracticeModal(row) {
      this.remotePractice = {
        sheetUrl: row.remote_practice_sheet_url || '',
        signUrl: row.remote_practice_sign_url || '',
        uploadUrl: row.remote_practice_upload_url || '',
        pepAllowed: !!row.practice_pep_allowed,
        examUrl: row.exam_url || ''
      };
      this.showRemotePracticeModal = true;
    },
    onRemotePracticePassed() {
      this.showRemotePracticeModal = false;

      if (this.remotePractice.examUrl) {
        window.location.href = this.remotePractice.examUrl;
      } else {
        window.location.reload();
      }
    },
    autoShowPracticeModal(rows) {
      if (this.practiceAutoShown) return;
      if (!/[?&]practice_required=1/.test(window.location.search)) return;

      const row = rows.find((r) => r.practice_block);
      if (!row) return;

      this.practiceSheetUrl = row.practice_sheet_url || '';
      this.showPracticeModal = true;
      this.practiceAutoShown = true;
    },
    examButtonHandler(row) {
      // Практика обязательна, но менеджер не отметил её прохождение — к экзамену не пускаем.
      // Проверяем раньше срока сдачи: практику нужно организовывать заранее,
      // а дата экзамена наступит сама.
      if (row.practice_block) {
        this.practiceSheetUrl = row.practice_sheet_url || '';
        this.showPracticeModal = true;
        return;
      }

      if (row.remote_practice_block) {
        this.openRemotePracticeModal(row);
        return;
      }

      // Проверяем ограничение по времени экзамена
      if (row.exam_limit) {
        // Показываем сообщение о том, что срок не наступил
        const message = `Не наступил срок окончания обучения. Экзамен станет доступен ${row.current_day}`;
        if (typeof Swal !== 'undefined') {
          Swal.fire({
            icon: 'info',
            title: 'Внимание!',
            text: message,
            confirmButtonText: 'Понятно'
          });
        } else {
          alert(message);
        }
        return;
      }

      // Проверяем, требуется ли куратор для экзамена
      if (row.exam_with_curator) {
        // Если экзамен требует куратора, показываем модальное окно
        this.selectedExam = row;
        this.enteredPinCode = '';
        this.pinError = false;
        this.showPinModal = true;
      } else {
        // Перенаправление на страницу экзамена, если куратор не требуется
        window.location.href = row.exam_url;
      }
    },
    verifyPinCode() {
      const entered = String(this.enteredPinCode || '').trim();
      const expected = String((this.selectedExam && this.selectedExam.exam_pin_code) || '').trim();
      if (entered && expected && entered === expected) {
        // Пин-код правильный, перенаправляем на экзамен
        this.pinError = false;
        this.showPinModal = false;
        window.location.href = this.selectedExam.exam_url;
      } else {
        // Пин-код неверный, показываем сообщение об ошибке
        this.pinError = true;
      }
    },
    closeModal() {
      // Закрытие модального окна и сброс данных
      this.showPinModal = false;
      this.enteredPinCode = '';
      this.pinError = false;
      this.selectedExam = null;
    }
  }
}
</script>

<style scoped>
.table {
  width: 100%;
  border: none;
  margin-bottom: 20px;
  background-color: white;
}

.table thead th {
  font-weight: bold;
  text-align: left;
  border: none;
  padding: 10px 15px;
  background: #656565;
  color: white;
  font-size: 14px;
}

.table thead tr th:first-child {
  border-radius: 8px 0 0 0;
}

.table thead tr th:last-child {
  border-radius: 0 8px 0 0;
}

.table tbody td {
  text-align: left;
  border: none;
  padding: 10px 15px;
  font-size: 14px;
}

.table tbody tr:nth-child(even) {
  background: #e6e6e6;
}

/* Стили для ссылок */
.link {
  color: rgb(248, 108, 1);
  text-decoration: underline;
}

.progress-bar {
  position: relative;
  text-align: center;
  font-weight: bold;
  color: rgb(255, 255, 255);
  /* Цвет текста */
}

/* Стили для кнопок */
.btn {
  padding: 5px 10px;
  cursor: pointer;
  text-wrap: nowrap;
  width: 100%;
}

.btn-primary {
  background-color: rgb(248, 108, 1);
  color: white;
  border: none;
  border-radius: 4px;
}

.btn-secondary {
  background-color: rgb(248, 108, 1);
  color: white;
  border: none;
  border-radius: 4px;
}

.btn-warning {
  background-color: #ffc107;
  color: #212529;
  border: none;
  border-radius: 4px;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
  text-align: center;
}

.btn-modal {
  margin-top: 5px;
}

.error {
  color: red;
  margin-top: 10px;
}

.progress-column {
  width: 10rem;
}

</style>
